import { BaseDataBind } from "./base";

/**
 * Data bind type for element's value property.
 */
export class ValueDataBind extends BaseDataBind
{
    public attributeName = 'data-bind-value';
    public selector = '[data-bind-value]';
    public eventNames = ['input', 'selectionchange'];

    protected setElementValue(element: Element, value: any)
    {
        (element as HTMLInputElement).value = value;
    }

    protected getElementValue(element: Element): any
    {
        return (element as HTMLInputElement).value;
    }
}

